import { shutdownIntecomOnClickEvents } from '../../../../components/IntercomComponent/IntercomComponent';

import css from './MobileBottomTabs.module.css';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { AvatarSmall } from '../../../../components/Avatar/Avatar';
import { useIntl } from 'react-intl';

export default function MobileBottomTabs(props) {
  const { handleIconClick, selectedTab, currentUser } = props;

  const intl = useIntl();
  const isMobile = typeof window !== 'undefined' && window?.innerWidth < 768;

  const mobileBottomTabsFeed = [
    {
      Icon: <ProfileIconCard type="marketplace_bottom_mobile_svg" />,
      tab: 'MARKETPLACE',
      label: intl.formatMessage({ id: 'MobileBottomTabs.marketplace' }),
      pageName: 'SearchPage',
      params: {},
    },
    {
      Icon: <ProfileIconCard type="community_bottom_mobile_svg" />,
      tab: 'COMMUNITY',
      label: intl.formatMessage({ id: 'MobileBottomTabs.community' }),
      pageName: 'CircleCommunityPage',
      params: {},
    },
    {
      Icon: <ProfileIconCard type="create_post_bottom_mobile_svg" />,
      tab: 'ADD_MENU',
      label: intl.formatMessage({ id: 'MobileBottomTabs.createPost' }),
      pageName: '',
      params: {},
    },
    {
      Icon: <ProfileIconCard type="discount_bottom_mobile_svg" />,
      tab: 'DISCOUNTS',
      label: intl.formatMessage({ id: 'MobileBottomTabs.discounts' }),
      pageName: 'DiscountsLandingPage',
      params: {},
    },
    {
      Icon: <AvatarSmall user={currentUser} disableProfileLink={true} />,
      tab: 'PROFILE',
      label: intl.formatMessage({ id: 'MobileBottomTabs.profile' }),
      pageName: 'ProfilePage',
      params: currentUser?.id ? { id: currentUser?.id?.uuid } : {},
    },
  ];

  return (
    <>
      <div className={css.bottomNavBar}>
        {mobileBottomTabsFeed.map(item => (
          <div
            key={item.tab}
            onClick={() => {
              handleIconClick(item);
              if (['ADD_MENU'].includes(item?.tab) && isMobile) {
                shutdownIntecomOnClickEvents();
              }
            }}
            className={selectedTab == item.tab ? css.iconTextSelected : css.iconText}
          >
            <div data-testid={`mobile-bottom-${item.tab}-tab`} style={{ position: 'relative' }}>
              {item.Icon}
              {item.notificationCount && item.notificationCount > 0 ? (
                <div className={css.notificationBadge}>{item.notificationCount}</div>
              ) : null}
            </div>
            <span className={css.tabText}>{item.label}</span>
          </div>
        ))}
      </div>
    </>
  );
}
